import React from "react";
import logo from "./DaVo.png";

export default function LoginPage() {
  return (

    <div className="login-shell">

      <div className="login-logo-wrapper">
        <a
            href="https://datavolwassenheid.nl"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Ga naar Datavolwassenheid.nl"
        >
        <img
          src={logo}
          alt="Datavolwassenheid.nl"
          className="login-logo-top"
        />
        </a>
      </div>

      <div className="login-card card-3d">
        <h1 className="login-title">Digital Boardroom</h1>

        <hr className="login-divider" />

        <a
          href="/.auth/login/aad?post_login_redirect_uri=/"
          className="login-btn"
        >
          Log in met Microsoft
        </a>

        <p className="login-footnote">
          Single Sign-On via Microsoft Entra ID. Geen wachtwoorden worden lokaal opgeslagen.
        </p>
      </div>

    </div>
  );
}